import * as Yup from "yup";

export const newCommissionPayoutSchema = Yup.object().shape({
  categoryId: Yup.number().required("Category is required"),
  commissionId: Yup.number().required("Category is required"),
  percentage: Yup.string().required("Percentage is required"),
});

export const newCommissionSchema = Yup.object().shape({
  name: Yup.string().required("Commission name is required"),
  description: Yup.string().optional(),
});

export const updateProductFeeSchema = Yup.object().shape({
  categoryId: Yup.number().required("Category is required"),
  productId: Yup.number().required("Product is required"),
  percentage: Yup.number()
    .min(0, "Percentage cannot be negative")
    .required("Percentage is required"),
    capAmount: Yup.number()
    .typeError("Fee cap must be a number")
    .min(0, "Fee cap cannot be negative")
    .required("Fee cap is required"),
});

export const newCategorySchema = Yup.object().shape({
  name: Yup.string().required("Category name is required"),
  code: Yup.string().required("Code is required"),
  description: Yup.string().optional(),
});

export const newProductSchema = Yup.object().shape({
  name: Yup.string().required("Product name is required"),
  description: Yup.string().optional(),
  percentage: Yup.string().required("Percentage is required"),
});
